import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import "../App.css"

// components
import GlobalHeader from '../components/GlobalHeader';
import GlobalFooter from '../components/GlobalFooter';
import BreadcrumbTrail from '../components/BreadcurmbTrail';
import Menu from '../components/Menu';
import ReportProblem from '../components/ReportProblem';

export default function PageNotFound() {
    const { t, i18n } = useTranslation('translation');
    const navigate = useNavigate();

    const handleGoHome = () => {
        navigate(`..`);
    };

    return (
        <div>
            <header>
                <GlobalHeader />
                <Menu />
                <BreadcrumbTrail />
            </header>

            <main property="mainContentOfPage" className="page-content container" typeof="WebPageElement">
                <h1 property="name" id="wb-cont" className="gc-thickline">
                    <span>{t("Page not found")}</span>
                </h1>

                <section>
                    <div className="region region-content">
                        <article className="landing-page full clearfix">
                            <div className="content">
                                <div className="layout layout--onecol">
                                    <div className="layout__region layout__region--content">
                                        <div data-block-plugin-id="field_block:node:landing_page:body" className="block block-layout-builder block-field-blocknodelanding-pagebody clearfix">
                                            <div className="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                                                <div className="error form-group">
                                                    <div className="box">
                                                        <div className="row">
                                                            <div className="col-xs-3 col-sm-2 col-md-2 text-center mrgn-tp-md">
                                                                <span className="glyphicon glyphicon-warning-sign glyphicon-error"></span>
                                                            </div>
                                                            <div className="col-xs-9 col-sm-10 col-md-10">
                                                                <h2 className="mrgn-tp-md">{t("We couldn't find that Web page")}</h2>
                                                                <p className="pagetag"><strong>{t("Error 404")}</strong></p>
                                                            </div>
                                                        </div>
                                                        <p className="mrgn-tp-md">
                                                            {t("We're sorry you ended up here. Sometimes a page gets moved or deleted, but hopefully we can help you find what you're looking for. What next?")}
                                                        </p>
                                                        <ul>
                                                            <li>
                                                                {t("Return to the")} <a href={`/${i18n.language}`} onClick={(e) => { e.preventDefault(); handleGoHome(); }}>
                                                                    {t("home page")}
                                                                </a>;
                                                            </li>
                                                            <li>
                                                                <a href="mailto:minepermitnavigator-navigateurdepermisminiers@nrcan-rncan.gc.ca">
                                                                    {t("Contact us")}
                                                                </a> {t("and we'll help you out.")}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </article>
                    </div>
                </section>
            </main>

            <ReportProblem />
            <GlobalFooter />
        </div>
    );
}